<template>
  <div class="order-address-content">
    <div ref="hiddenContainer"
         class="hidden"></div>
    <a-scroll-table class="scrollTable"
                    :columns="ORDER_COLUMNS"
                    :data-source="convertOrderInfo?.deliver?.length ? convertOrderInfo.deliver : convertOrderInfo?.items"
                    :pagination="false"
                    row-key="id">
      <template #bodyCell="{ column, text: items, record }">
        <template v-if="column.dataIndex === 'deliverItems'">
          <div v-if='convertOrderInfo?.deliver?.length'>
            <div v-for="item in items"
                 :key="item.id"
                 class="item-flex">
              <div v-for="orderItem in convertOrderInfo?.items">
                <div v-if="item.order_item_id === orderItem.id">
                  <div v-if="orderItem.is_custom && orderItem.customSpu != null"
                       class="viewer">
                    <CustomizedImagePreview :customized-data="mergeCustomAreaData(orderItem)" />
                  </div>
                  <img v-else
                       :src="toUrl(orderItem.image || orderItem.spu_customable_image)"
                       class="viewer" />
                </div>
              </div>
              <div class="item-info">
                {{ item.orderItem?.spu_name }}
                <div class="item-attr">
                  <span v-for="(attr, index) in convertAttrs(item.orderItem?.sku_attrs)"
                        :key="index">
                    {{ attr.name }}:<span class="attr_color">{{ attr.value
                    }}</span>
                  </span>
                </div>
              </div>
              <span class="item-quality">
                x {{ item.quality }}
              </span>
            </div>
          </div>
          <div v-else
               class="item-flex">
            <div>
              <div v-if="record.is_custom"
                   class="viewer">
                <CustomizedImagePreview :customized-data="mergeCustomAreaData(record)" />
              </div>
              <img v-else
                   :src="toUrl(record.image)"
                   class="viewer" />
            </div>
            <div class="item-info">
              {{ record.spu_name }}
              <div class="item-attr">
                <span v-for="(attr, index) in convertAttrs(record.sku_attrs)"
                      :key="index">
                  {{ attr.name }}:<span class="attr_color">{{ attr.value }}</span>
                </span>
              </div>
            </div>
            <span class="item-quality">
              x {{ record.quality }}
            </span>
          </div>
        </template>
        <template v-if="column.dataIndex === 'deliver_status'">
          <div v-if='convertOrderInfo?.deliver?.length'>
            <div v-if="convertOrderInfo.status === 8">{{ $t('order.OrderAddress.cancelled') }}</div>
            <div v-else-if="convertOrderInfo.status === 1">{{ $t('order.OrderAddress.pendingPayment') }}</div>
            <div v-else>
              <div v-if="record.deliver_status === 0 || !record.deliver_status">
                {{ $t('order.OrderAddress.pending') }}</div>
              <div v-if="record.deliver_status === 1">{{ $t('order.OrderAddress.shipped') }}</div>
              <div v-if="record.deliver_status === 2">{{ $t('order.OrderAddress.received') }}</div>
            </div>
          </div>
          <div v-else>
            <div v-for="item in statusType"
                 :key="item.value"><span v-if="item.value == convertOrderInfo?.status">{{ item.label }}</span></div>
          </div>
        </template>
        <template v-if="column.dataIndex === 'receive_address'">
          <div v-if="convertOrderInfo?.deliver?.length">
            <div v-if="record.express_company_id == 17">{{ $t('order.OrderAddress.selfPickup') }}</div>
            <div v-else>
              <div v-if='convertOrderInfo?.deliver?.length'
                   class="receive-address"
                   @click="copy(record)">
                <div>
                  <span>{{ record.receiver }}</span>
                  <span class="receiver-margin">{{ record.receiver_phone }}</span>
                </div>
                <div>
                  {{ (record.receiver_province || '') + (record.receiver_city || '') + (record.receiver_district || '')
                    + (record.receiver_street || '') }}
                </div>
              </div>
              <div v-else
                   @click="copy(convertOrderInfo)">
                <div class="receive-address">
                  <div>
                    <span>{{ convertOrderInfo?.receiver }}</span>
                    <span class="receiver-margin">{{ convertOrderInfo?.receiver_phone }}</span>
                  </div>
                  <div>{{ convertOrderInfo?.receive_address }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div v-if="convertOrderInfo?.express_company_id == 17">{{ $t('order.OrderAddress.selfPickup') }}</div>
            <div v-else>
              <div v-if='convertOrderInfo?.deliver?.length'
                   class="receive-address"
                   @click="copy(record)">
                <div>
                  <span>{{ record.receiver }}</span>
                  <span class="receiver-margin">{{ record.receiver_phone }}</span>
                </div>
                <div>
                  {{ record.receiver_province + record.receiver_district +
                    record.receiver_district + record.receiver_street + record.receive_address }}
                </div>
              </div>
              <div v-else
                   @click="copy(convertOrderInfo)">
                <div class="receive-address">
                  <div>
                    <span>{{ convertOrderInfo?.receiver }}</span>
                    <span class="receiver-margin">{{ convertOrderInfo?.receiver_phone }}</span>
                  </div>
                  <div>{{ convertOrderInfo?.receive_address }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- 快递详情 -->
        <template v-if="column.dataIndex === 'express_number'">
          <div v-if='convertOrderInfo?.deliver?.length'>
            <div v-if="record.express_company_id == 17">
              <div class="express-self-pickup">{{ $t('order.OrderAddress.selfPickupAddress') }}</div>
              <div class="express-self-pickup">{{ $t('order.OrderAddress.selfPickupCode') }}：<span
                      class="operation-text">{{
                        convertOrderInfo.number }}</span></div>
            </div>
            <div v-else>
              <p>{{ currentExpress(record.express_company_id)?.name }}</p>
              <a class="operation-text"
                 @click="expressClick(record)">{{ record.express_number }}</a>
            </div>
          </div>
          <div v-else>
            <div v-if="convertOrderInfo?.express_company_id == 17">
              <div class="express-self-pickup">{{ $t('order.OrderAddress.selfPickupAddress') }}</div>
              <div class="express-self-pickup">{{ $t('order.OrderAddress.selfPickupCode') }}：<span
                      class="operation-text">{{
                        convertOrderInfo?.number }}</span>
              </div>
            </div>
            <div v-else>
              <p>{{ currentExpress(convertOrderInfo?.express_company_id!)?.name }}</p>
              <a class="operation-text"
                 @click="expressClick(convertOrderInfo)">{{ convertOrderInfo?.express_number }}</a>
            </div>
          </div>
        </template>
        <template v-if="column.dataIndex === 'express_fee'">
          {{ convertOrderInfo?.deliver?.length ? (record.express_fee || 0) : (convertOrderInfo?.express_fee || 0) }}
        </template>
        <template v-if="column.dataIndex === 'operation'">
          <div class="operation-text">
            <p v-if="isAdmin && convertOrderInfo!.status === 4 && (record.deliver_status === 0 || !record.deliver_status)"
               @click="openOrderNumberVisible(record)">
              {{ $t('order.OrderAddress.deliver') }}</p>
            <a-popconfirm v-else-if='convertOrderInfo!.status === 5 && record.deliver_status === 1'
                          :title="$t('order.OrderAddress.title')"
                          :ok-text="$t('order.OrderAddress.ok')"
                          :cancel-text="$t('order.OrderAddress.cancel')"
                          @confirm="confirmReceived(record)">
              <p>{{ $t('order.OrderAddress.confirmReceipt') }}</p>
            </a-popconfirm>
          </div>
        </template>
      </template>
    </a-scroll-table>
    <a-modal v-model:visible="orderNumberVisible"
             :title="$t('order.OrderAddress.enterExpressOrderNumber')"
             :confirm-loading="confirmLoading"
             @ok="confirmSchiff(false)"
             @cancel="orderNumberVisible = false">
      <a-row style="padding: 5px 20px;">
        <a-col :span="4"
               style="line-height: 32px;">{{ $t('order.OrderAddress.express') }}：</a-col>
        <a-col>
          <a-input v-model:value="express_number"
                   style="width:300px;"
                   :placeholder="$t('order.OrderAddress.enterExperss')" />
        </a-col>
      </a-row>
    </a-modal>
  </div>
</template>
<script setup lang="ts">
import { toUrl } from "@/utils"
import { onMounted, ref, watch, computed } from "vue"
import { getExpress, receivedOrder } from "./api"
import { message, type TableColumnsType } from 'ant-design-vue'
import clipboard from "vue-clipboard3"
import { AScrollTable, CustomizedImagePreview } from '@iota-cn/ui-components'
import { useI18n } from "vue-i18n"
const { t } = useI18n()
interface OrderDetails {
  id: number
  number: string
  pay_amount: number
  out_trade_number: string
  receive_address: string
  express_number: string
  remark: string
  status: number
  items: any[]
  pay_type: number
  express_company_id: number
  receiver: string
  receiver_phone: string
  createdAt: string
  pay_at: string
  deliver_at: string
  express_fee: string
  selectCoupon: any
  discount_amount: number
  refunds: any
  deliver: any
}

const statusType = computed(() => [
  {
    label: t('order.OrderAddress.all'),
    value: '',
  },
  {
    label: t('order.OrderAddress.pendingPayment'),
    value: 1,
  }, {
    label: t('order.OrderAddress.pendingProduction'),
    value: 2,
  },
  {
    label: t('order.OrderAddress.inProduction'),
    value: 3,
  },
  {
    label: t('order.OrderAddress.pendingDelivery'),
    value: 4,
  },
  {
    label: t('order.OrderAddress.shipped'),
    value: 5,
  }, {
    label: t('order.OrderAddress.completed'),
    value: 6,
  }, {
    label: t('order.OrderAddress.refunding'),
    value: 7,
  }, {
    label: t('order.OrderAddress.cancelled'),
    value: 8,
  }, {
    label: t('order.OrderAddress.duringAfterSale'),
    value: 9,
  }
])
const hiddenContainer = ref()
const sharedOnCell = (_: any, index: any) => {
  if (!convertOrderInfo.value?.deliver?.length) {
    if (index > 0)
      return { rowSpan: 0 } as any
    else
      return { rowSpan: convertOrderInfo.value?.items.length } as any
  }
}

const ORDER_COLUMNS = computed<TableColumnsType>(() => [
  {
    title: t('order.OrderAddress.goods'),
    dataIndex: 'deliverItems',
    width: '30%',
    align: 'center',
    ellipsis: true,
  },
  {
    title: t('order.OrderAddress.recipientInformation'),
    dataIndex: 'receive_address',
    width: '20%',
    align: 'center',
    ellipsis: true,
    customCell: sharedOnCell
  },
  {
    title: t('order.OrderAddress.logisticsInformation'),
    dataIndex: 'express_number',
    width: '20%',
    align: 'center',
    ellipsis: true,
    customCell: sharedOnCell
  },
  {
    title: t('order.OrderAddress.transactionStatus'),
    dataIndex: 'deliver_status',
    width: '10%',
    align: 'center',
    ellipsis: true,
    customCell: sharedOnCell
  },
  {
    title: t('order.OrderAddress.expressFee'),
    dataIndex: 'express_fee',
    width: '10%',
    align: 'center',
    ellipsis: true,
    customCell: sharedOnCell
  },
  {
    title: t('order.OrderAddress.operation'),
    dataIndex: 'operation',
    fixed: 'right',
    align: 'center',
    width: '10%',
    customCell: sharedOnCell
  }
])

const props = defineProps<{
  orderInfo: OrderDetails
  isAdmin: boolean
}>()

const confirmLoading = ref<boolean>(false)
const orderNumberVisible = ref<boolean>(false)
const convertOrderInfo = ref<OrderDetails>()
const expressList = ref<any[]>([])
const express_number = ref<string>()
const currentDeliverId = ref<number>(0)

watch(() => props.orderInfo.id, () => {
  if (props.orderInfo)
    convertOrderInfo.value = JSON.parse(JSON.stringify(props.orderInfo))
}, {
  immediate: true
})

onMounted(async () => {
  const expressCompanies: any = await getExpress()
  expressList.value = expressCompanies.companies
})

const emit = defineEmits([
  'expressClick',
  'confirmUpdateOrder'
])

const mergeCustomAreaData = (item: any) => {
  return Object.assign(
    {},
    {
      image: renderImageBaseUrl(item),
      customArea: Object.assign(
        item.customSpu?.customizedImages[theFirstCustomizedArea(item)]?.customableImage?.custom_areas ||
        item.spu_custom_areas
        || {},
        { boundingRect: item.customSpu?.customizedImages[theFirstCustomizedArea(item)]?.customized_areas.boundingRect }
      ),
      customizedImage: item.image + `?x-oss-process=image/resize,w_50/quality,q_90` || "",
      width: 1000,
      height: 1000,
      cssWidth: 50,
      cssHeight: 50,
    },
  )
}

// 临时解决方案 接口返回的customizedImages顺序不一致 order排序以后 sql太长不生效 加入 separate: true会丢失custom spu id 导致数据为空 
const theFirstCustomizedArea = (record: any) => {
  if (record.customSpu && record.customSpu.customizedImages && record.customSpu.customizedImages.length)
    return record.customSpu.customizedImages.reduce((minIdx: number, curr: any, idx: number, array: any[]) => {
      return curr.custom_area_id < array[minIdx].custom_area_id ? idx : minIdx
    }, 0)
  else return 0
}

const currentExpress = (id: number) => {
  return expressList.value.find((r) => r.id === id)
}

const renderImageBaseUrl = (record: any) => {
  const baseHeightRatio = Math.round(record.spu_custom_height * (200 / record.spu_custom_width))
  return toUrl(record.spu_customable_image) + `?x-oss-process=image/resize,h_${baseHeightRatio},m_lfit`
}

const openOrderNumberVisible = (record: any) => {
  const express_company_id = convertOrderInfo.value?.deliver?.length ? record.express_company_id : convertOrderInfo.value?.express_company_id
  currentDeliverId.value = convertOrderInfo.value?.deliver?.length ? record.id : 0
  if (express_company_id != 17)
    orderNumberVisible.value = true
  else {
    confirmSchiff(true)
  }
}

const convertAttrs = (attrs: any[]) => {
  if (attrs) {
    const arr = [] as any
    attrs.forEach((a) => {
      const data = {
        name: '',
        value: ''
      }
      data.name = a.attribute.name
      data.value = a.object_value ? a.object_value.name : a.value
      arr.push(data)
    })
    arr.sort(sortBy('name', false))
    return arr
  }
}

const sortBy = (attr: any, rev: any) => {
  // 第二个参数没有传递 默认升序排列
  if (rev == undefined) {
    rev = 1
  } else {
    rev = (rev) ? 1 : -1
  }

  return function (a: any, b: any) {
    a = a[attr]
    b = b[attr]
    if (a < b) {
      return rev * -1
    }
    if (a > b) {
      return rev * 1
    }
    return 0
  }
}

const copy = async (item: any) => {
  let text: string
  if (convertOrderInfo.value?.deliver?.length) {
    text = item.receiver + ' ' + item.receiver_phone + ' ' + item.receiver_province + item.receiver_district +
      item.receiver_district + item.receiver_street + item.receive_address as string
  } else {
    text = item.receiver + ' ' + item.receiver_phone + ' ' + item.receive_address as string
  }

  const { toClipboard } = clipboard()
  try {
    await toClipboard(text)
    message.success(t('order.OrderAddress.copySuccessful'))
  } catch (e) {
    message.error(t('order.OrderAddress.copyFailed') + e)
  }
}

const confirmReceived = async (record: any) => {
  const receivedInfo = {
    is_new: !!convertOrderInfo.value?.deliver?.length,
    deliver_status: 2
  } as any
  if (!convertOrderInfo.value?.deliver?.length)
    receivedInfo.order_id = convertOrderInfo.value?.id
  await receivedOrder(record.id, receivedInfo).then(() => {
    message.success(t('order.OrderAddress.orderCompleted'))
    if (convertOrderInfo.value?.deliver?.length)
      record.deliver_status = 2
    else
      convertOrderInfo.value!.status = 6

    emit('confirmUpdateOrder', true)
  }).catch((err: any) => {
    message.error(t('order.OrderAddress.errMsg') + err)
  })
}

const confirmSchiff = async (isAbholen: boolean) => {
  confirmLoading.value = true
  const schiffInfo = {
    is_new: !!convertOrderInfo.value?.deliver?.length,
    deliver_status: 1,
    express_number: express_number.value
  } as any
  if (isAbholen)
    delete schiffInfo.express_number
  else if (!express_number.value) {
    confirmLoading.value = false
    return message.error(t('order.OrderAddress.orderNumberEmpty'))
  }
  if (!convertOrderInfo.value?.deliver?.length)
    schiffInfo.order_id = convertOrderInfo.value?.id
  await receivedOrder(currentDeliverId.value, schiffInfo).then(() => {
    message.success(t('order.OrderAddress.deliveryCompleted'))
    if (isAbholen) {
      convertOrderInfo.value!.status = 5
    } else {
      convertOrderInfo.value?.deliver.forEach((r: any) => {
        if (r.id === currentDeliverId.value)
          r.deliver_status = 1
      })
    }
    orderNumberVisible.value = false
    express_number.value = ''
    emit('confirmUpdateOrder', true)
  }).catch((err: any) => {
    message.error(t('order.OrderAddress.errMsg') + err)
  })
  confirmLoading.value = false
}

const expressClick = (record: any) => {
  emit('expressClick', record)
}

</script>
<style scoped lang="less">
.order-address-content {
  width: 100%;
  height: 100%;

  .hidden {
    width: 50px;
    height: 50px;
    position: absolute;
    visibility: hidden;
    display: block;
  }

  .viewer {
    min-width: 50px;
    min-height: 50px;
    max-width: 50px;
    max-height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;

    @-moz-document url-prefix() {
      :deep(.fabric-div) {
        width: 50px !important;
        height: 50px !important;
      }

      :deep(.canvas-container) {
        width: 50px !important;
        height: 50px !important;
      }

      :deep(.lower-canvas) {
        width: 50px !important;
        height: 50px !important;
      }

      :deep(.upper-canvas) {
        width: 50px !important;
        height: 50px !important;
      }
    }
  }

  .operation-text {
    color: #009ad6;
    cursor: pointer;
  }

  .scrollTable {
    flex: 1;
    overflow: hidden;
    height: 100%;
  }

  .item-flex {
    display: flex;
    justify-content: space-around;
    align-items: center;
    text-wrap: wrap;
    white-space: pre-wrap;
    text-align: start;

    .item-info {
      flex: 1;
      margin-left: 20px;
    }

    .item-attr {
      font-size: 12px;
    }
  }

  .express-self-pickup {
    text-align: start;
    text-wrap: wrap;
    word-break: break-all;
  }

  .item-quality {
    text-align: right;
  }

  .receive-address {
    text-align: start;
    text-wrap: wrap;

    .receiver-margin {
      margin-left: 10px;
    }
  }
}
</style>